import { render, staticRenderFns } from "./WTags.vue?vue&type=template&id=4c6644c4&"
import script from "./WTags.vue?vue&type=script&lang=js&"
export * from "./WTags.vue?vue&type=script&lang=js&"
import style0 from "./WTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports